import styled from 'styled-components';

export const CarouselWrapper = styled.div`
  .ant-carousel {
    .slick-slide {
      height: auto !important;
      > div {
        height: 100%;

        @media (max-width: ${({ theme }) => theme.mediaQueries.sm}) {
          max-height: 60vh;
          overflow-y: auto;
        }
      }
    }
    .slick-list {
      height: auto !important;
    }
    .slick-track {
      height: auto !important;
    }
  }
`;
